import { useState } from "react";
import { api } from "@/lib/api";
import { ThumbsUp, Lightbulb, Meh } from "lucide-react";

const OPTIONS = [
  { key: "utile", label: "Utile", Icon: ThumbsUp },
  { key: "interessant", label: "Intéressant", Icon: Lightbulb },
  { key: "mitige", label: "Mitigé", Icon: Meh },
];

/** Barre de réaction express pour lancer l'engagement (et la discussion Facebook).
 *  Un seul vote par visiteur (verrou local), compteurs persistés côté serveur. */
export default function PressReactions({ slug, initial = {}, testId = "press-reactions" }) {
  const storeKey = `press-react-${slug}`;
  const [counts, setCounts] = useState(initial || {});
  const [voted, setVoted] = useState(() => {
    try { return localStorage.getItem(storeKey) || ""; } catch { return ""; }
  });

  const react = async (key) => {
    if (voted) return;
    setVoted(key);
    setCounts((c) => ({ ...c, [key]: (c[key] || 0) + 1 }));
    try { localStorage.setItem(storeKey, key); } catch { /* ignore */ }
    try {
      const { data } = await api.post(`/press-review/${slug}/react`, { key });
      if (data?.reactions) setCounts(data.reactions);
    } catch { /* ignore */ }
  };

  return (
    <div className="mt-6 rounded-2xl border border-slate-200 bg-white p-4" data-testid={testId}>
      <div className="text-sm font-bold text-slate-700">Cette actu vous a-t-elle été utile ?</div>
      <div className="mt-3 flex flex-wrap gap-2">
        {OPTIONS.map(({ key, label, Icon }) => {
          const active = voted === key;
          return (
            <button key={key} onClick={() => react(key)} disabled={!!voted} data-testid={`${testId}-${key}`}
              className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-semibold transition-colors ${active ? "bg-[#E05638] border-[#E05638] text-white" : voted ? "bg-slate-50 border-slate-200 text-slate-500" : "bg-white border-slate-200 text-slate-700 hover:border-[#E05638] hover:text-[#E05638]"}`}>
              <Icon size={16} /> {label}
              {counts[key] > 0 && <span className={`text-xs font-bold ${active ? "text-white/90" : "text-slate-400"}`}>{counts[key]}</span>}
            </button>
          );
        })}
      </div>
      {voted && <div className="mt-2 text-xs text-slate-500" data-testid={`${testId}-thanks`}>Merci pour votre retour ! Partagez l'info autour de vous 👇</div>}
    </div>
  );
}
